import React from 'react';
import { Card, Row, Col, Table } from 'antd';
import { HeartOutlined, WarningOutlined } from '@ant-design/icons';
import AnalyticsCard from '../../components/shared/AnalyticsCard';
import ChartContainer from '../../components/shared/ChartContainer';
import { mockClientAnalyticsData, mockRetentionByTier } from '../data/mockData';



const RetentionAnalysis: React.FC = () => {
  const { retention } = mockClientAnalyticsData;

  // Prepare cohort chart data
  const cohortData = {
    labels: retention.cohortAnalysis.map(item => `${item.cohort} - Period ${item.period}`),
    datasets: [
      {
        label: 'Retention Rate (%)',
        data: retention.cohortAnalysis.map(item => item.retentionRate),
        borderColor: '#52c41a',
        backgroundColor: 'rgba(82, 196, 26, 0.1)',
        fill: true,
      },
    ],
  };

  // Retention by tier chart
  const tierRetentionData = {
    labels: mockRetentionByTier.map(item => item.tier),
    datasets: [
      {
        label: 'Retention Rate (%)',
        data: mockRetentionByTier.map(item => item.retentionRate),
        backgroundColor: ['#1890ff', '#52c41a', '#faad14'],
      },
    ],
  };

  // Table columns for cohort analysis
  const cohortColumns = [
    {
      title: 'Cohort',
      dataIndex: 'cohort',
      key: 'cohort',
    },
    {
      title: 'Period',
      dataIndex: 'period',
      key: 'period',
      render: (period: number) => `Month ${period}`,
    },
    {
      title: 'Retention Rate',
      dataIndex: 'retentionRate',
      key: 'retentionRate',
      render: (rate: number) => `${rate.toFixed(1)}%`,
    },
    {
      title: 'Client Count',
      dataIndex: 'clientCount',
      key: 'clientCount',
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <AnalyticsCard
            title="Retention Rate"
            value={retention.retentionRate}
            format="percentage"
            trend="up"
            change={1.8}
            subtitle="vs last month"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Churn Rate"
            value={retention.churnRate}
            format="percentage"
            trend="down"
            change={-1.8}
            subtitle="vs last month"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Average Lifespan"
            value={retention.averageLifespan}
            format="number"
            trend="up"
            change={0.7}
            subtitle="months"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="At-Risk Clients"
            value={28}
            format="number"
            trend="down"
            change={-5}
            subtitle="vs last month"
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={12}>
          <ChartContainer
            title={
              <span>
                <HeartOutlined /> Cohort Retention Analysis
              </span>
            }
            type="line"
            data={cohortData}
            height={300}
          />
        </Col>
        <Col span={12}>
          <ChartContainer
            title="Retention Rate by Tier"
            type="bar"
            data={tierRetentionData}
            height={300}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card 
            title={
              <span>
                <WarningOutlined /> Detailed Cohort Analysis
              </span>
            }
          >
            <Table
              columns={cohortColumns}
              dataSource={retention.cohortAnalysis}
              rowKey={(record) => `${record.cohort}-${record.period}`}
              pagination={{ pageSize: 8 }}
              size="small"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RetentionAnalysis; 